<template>
  <div class="expired">
    <div class="expired__content">
      <p class="text">この配信は終了しました。</p>
      <p class="text" v-if="!isCast">他の配信をぜひお楽しみください。</p>
      <button class="button" @click="move">{{ isCast ? "配信予定管理" : "出勤予定一覧" }}</button>
    </div>
  </div>
</template>

<script>
import { analyticsLog } from '@/utils/analytics';

export default {
  name: 'LiveExpired',
  computed: {
    isCast() {
      return this.$store.getters['user/isPerformer'];
    },
  },
  mounted() {
    analyticsLog('配信終了画面【表示時】', {'キャストID': this.$route.params.castId});
  },
  methods: {
    move() {
      this.$router.push(this.isCast ? '/cast/mypage/liveSchedule' : '/live/upcoming');
    }
  },
};
</script>

<style lang="scss" scoped>
.expired {
  height: 70vh;
  display: flex;
  justify-content: center;
  padding-top: 80px;
  &__content {
    text-align: center;
    & .text {
      margin-top: 20px;
      font-weight: 600;
      font-size: 18px;
      line-height: 21px;
      color: #333333;
    }

    & .button {
      margin-top: 40px;
      padding-left: 3em;
      padding-right: 3em;
      color: #FFFFFF;
      font-size: 16px;
      font-weight: 600;
      background: linear-gradient(#703A3A, #451B1B);
      border: 1px solid #CCB21A;

      &:hover {
        color: #FFFFFF;
      }
    }
  }
}
</style>
